<template>
  <img src="@/assets/images/logos/company-logo-elorda.webp"/>
</template>
<script setup>
</script>